import React, { useEffect, useState } from 'react'
import TeamMemberStyles from './EditTeamMember.module.css'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
import PostJobStyles from '../PostJob/PostJob.module.css'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const EditTeamMember = () => {
  const name = useSelector((state) => state.globalData.name);
  const count = useSelector((state) => state.globalData.notificationCount);
  const dispatch = useDispatch()

  const location = useLocation()
  const data = location.state

  const navigate = useNavigate()
  const inputRef = React.useRef();


  const [formData, setFormData] = useState({
    teammateName: '',
    teammatePosition: '',
    teammateInfo: '',
    file: null,
  });

  const [source, setSource] = React.useState();
  const [fileName, setFileName] = React.useState('');
  const [imageSelect, setImageSelect] = useState(false);

  useEffect(() => {
    if (data.newteamImageName) {
    const fetchImage = async () => {
      try {
        const imageResponse = await axios.get(
          `${process.env.REACT_APP_COSMOSADMIN}/team/file/${data.newteamImageName}`
        );
       
        setSource(imageResponse.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchImage();
  }
  }, [data.newteamImageName]);

  useEffect(() => {
    if (data) {
      setFormData({
        teammateName: data.team.teammateName || '',
        teammatePosition: data.team.teammatePosition || '',
        teammateInfo: data.team.teammateInfo,
        file: null, // reset file when data changes
      });
    }
  }, [data]);



  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFileName(file.name)
    const url = URL.createObjectURL(file);
    setSource(url);
    setImageSelect(true)
    setFormData({ ...formData, file: file });
  };

  const handleChoose = (event) => {
    inputRef.current.click();
  };


  const discardImage = (event) => {
    setSource(null)
    setFileName('')
    setFormData((prevData) => ({
      ...prevData,
      file: null,
    }));
    inputRef.current.value = ""
    setImageSelect(false)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    const textData = {
      teammateName: formData.teammateName,
      teammatePosition: formData.teammatePosition,
      teammateInfo: formData.teammateInfo,
    };


    try {
      if (
        textData.teammateName !== data.team.teammateName ||
        textData.teammatePosition !== data.team.teammatePosition ||
        textData.teammateInfo !== data.team.teammateInfo
      ) {
      const businessResponse = await axios.post(
        `${process.env.REACT_APP_COSMOSADMIN}/team/updateTeamDetails/${data.team.teammateId}`,
        textData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      dispatch(setNotificationCount({
        count: count + 1,
      }))

      alert('Member Updated.');
      navigate('/meetourteam');
    }
    } catch (error) {
      console.error(error)
    }


    if (formData.file) {
      const formDataObj = new FormData();
      formDataObj.append('file', formData.file);

      try {
        const imageResponse = await axios.post(
          `${process.env.REACT_APP_COSMOSADMIN}/team/updateTeamImagebyId/${data.teamImageId}`,
          formDataObj,
          {
            headers: {
              'Content-Type': 'image/jpeg',
            },
          }
        );
        
       
      alert('Member Updated.');
      navigate('/meetourteam');
      const url = URL.createObjectURL(formData.file);
      setSource(url)
      } catch (error) {
        console.error(error);
      }
    }

    discardImage();
  };




  return (
    <div className={TeamMemberStyles.teammemberMain}>
      <div className={TeamMemberStyles.teammemberContent}>
        <form action="" className={TeamMemberStyles.teammemberForm} onSubmit={handleSubmit} encType='multipart/form-data'>

          <label className={TeamMemberStyles.teammemberFormLabel}>Name</label>
          <input className={TeamMemberStyles.teammemberFormText}
            type="text"
            value={formData.teammateName}
            name='teammateName'
            onChange={(event) => setFormData({ ...formData, teammateName: event.target.value })}
          />

          <label className={TeamMemberStyles.teammemberFormLabel}>Position</label>
          <input className={TeamMemberStyles.teammemberFormText}
            type="text"
            value={formData.teammatePosition}
            name='teammatePosition'
            onChange={(event) => setFormData({ ...formData, teammatePosition: event.target.value })}
          />


          <label className={TeamMemberStyles.teammemberFormLabel}>Description</label>
          <div className={PostJobStyles.reactQill} >
            <ReactQuill theme="snow" value={formData.teammateInfo}
              onChange={(value) => setFormData({ ...formData, teammateInfo: value })} />
          </div>


          <label className={TeamMemberStyles.teammemberFormLabel}>Upload</label>
          <div className={TeamMemberStyles.ImgInput}>
            <input
              ref={inputRef}
              className={TeamMemberStyles.ImgInput_input}
              type="file"
              onChange={handleFileChange}
            />
            {!source && <button type='button' onClick={handleChoose}>Browse</button>}
            {source && (
              <img
                className={TeamMemberStyles.ImgInput_img}
                width="100%"
                src={`${process.env.REACT_APP_COSMOSADMIN}/team/file/${data.newteamImageName}`}
                alt='uploadedimage'
              />
            )}
          </div>
          <div className={TeamMemberStyles.ImgInput_footer}>
            {imageSelect ?
              <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                {fileName}
              </div> :
              ''}
          </div>
          <DeleteForeverOutlinedIcon onClick={discardImage} sx={{ cursor: 'pointer' }} />
          <Button variant='contained' type='submit' className={TeamMemberStyles.saveChanges}>Save changes</Button>
        </form>
      </div>
    </div>
  )
}

export default EditTeamMember